module.exports = __webpack_public_path__ + "img/icon4.d685a060.svg";